(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('formdata', function(event) {
 const key = 'properties[Fabric Type]';
 const value = event.formData.get(key);
 if (typeof value === 'string' && !value.trim()) event.formData.delete(key);
}, true);
  } catch(e) { console.error(e); }
})();

})();
